global.updatingPreferences = 0;

$(document).ready(function () {
    //Set Basil to store javascript objects as JSON
    Basil.localStorage.options.raw = false;
    Basil.sessionStorage.options.raw = false;
    Basil.cookie.options.raw = false;

    //Add custom helper methods
    setHelperMethods();

    if (!Basil.sessionStorage.isSet("dismissedAlerts")) {
        Basil.sessionStorage.set("dismissedAlerts", {});
    }

    if (!Basil.sessionStorage.isSet("xSource")) {
        Basil.sessionStorage.set("xSource", document.referrer );
    }

    var currentxSource = Basil.sessionStorage.get("xSource");
    if (currentxSource !== document.referrer) {
        if (isHostUsajobs(currentxSource) && !isHostUsajobs(document.referrer)) {
            Basil.sessionStorage.set("xSource", document.referrer);
        }
    }
    
    if (!Basil.sessionStorage.isSet("userObject") || Basil.cookie.isSet("usaj-u")) {
        window.localStorage.setItem("usaj-l", true);
        global.LoadingSessionPreferences = true;
        retrieveUserPreferences();
    } else {
        displayHeaderContent(Basil.sessionStorage.get("userObject"));
        document.dispatchEvent(new Event("session-loaded"));
        if (typeof updateSessionContent === 'function') {
            updateSessionContent();
        }
    }

    $(document).on("click", ".usaj-sign-out, .usajobs-home__sign-out", function () {
        signOut($(this));
    });

    $(document).on("click", ".user-logged-out", function () {
        signIn($(this));
    });

    window.addEventListener("storage", storageChange, false);
});

function signIn(el) {
    if ($(el).hasClass("disabled-link")) {
        return false;
    } else {
        $(el).addClass("disabled-link");
        location = "/Applicant/Profile/Dashboard/";
    }
}

function signOut(el) {
    if ($(el).hasClass("disabled-link")) {
        return false;
    } else {
        $(".usaj-sign-out").addClass("disabled-link");
        $(".usajobs-home__sign-out").addClass("disabled-link");
        Basil.sessionStorage.remove("userObject");
        Basil.sessionStorage.remove("dismissedAlerts");
        Basil.cookie.remove("usaj-cid");
        window.localStorage.setItem("usaj-l", false);
        location = "/Account/LogOff/";
    }
}

global.retrieveUserPreferences = function(redirectURL) {
    var referrer = document.referrer;
    updatingPreferences = 1;
    $.post("/Account/RetrieveUserPreferences", { 'referrer': referrer } , function (data) {
        data.LastLoad = new Date().getTime();
        Basil.sessionStorage.set("userObject", data);
        Basil.cookie.remove("usaj-u");
        displayHeaderContent(data);
        if (data.AssignedFeatures.length > 0) {
            Basil.cookie.set("usaj-f", data.AssignedFeatures, {'expireDays': 0,'secure': true });
        }
        global.isSessionLoaded = true;
        document.dispatchEvent(new Event("session-loaded"));
        if (typeof updateSessionContent === 'function') {
            updateSessionContent();
        }
        updatingPreferences = 0;
        if (redirectURL !== null && redirectURL !== undefined) {
            location.href = redirectURL;
        }
    });
}

global.setHelperMethods = function() {
    ["cookie", "localStorage", "sessionStorage"].forEach(function (method) {
        Basil[method].isSet = function (name) {
            return Basil[method].get(name) !== null;
        };
    });
}

global.addSavedJobsInSession = function(documentID) {
    var userObject = Basil.sessionStorage.get("userObject");
    userObject.SavedJobs[documentID] = true;
    Basil.sessionStorage.set("userObject", userObject);
}

global.removeSavedJobsInSession = function(documentID) {
    var userObject = Basil.sessionStorage.get("userObject");
    delete userObject.SavedJobs[documentID];
    Basil.sessionStorage.set("userObject", userObject);
}

function displayHeaderContent(userObject) {
    if (userObject.IsAuthenticated) {
        $('.user-logged-in').find('.usajobs-nav__account_name').html(userObject.NameAbbreviation);
        $('.user-logged-in').find('.usajobs-nav__first_name').html(userObject.FirstName.length > 15 ? userObject.NameAbbreviation : userObject.FirstName);
        $('.user-logged-in').removeClass("usaj-hidden");
        $('.user-logged-out').addClass("usaj-hidden");
        $(".usaj-sign-out").removeClass("usaj-hidden");
    } else {
        $('.user-logged-out').find('.usajobs-nav__account_name').html("Sign in");
        $('.user-logged-out').find('.usajobs-nav__first_name').html("Sign in");
        $('.user-logged-in').addClass("usaj-hidden");
        $('.user-logged-out').removeClass("usaj-hidden");
    }
}

function isHostUsajobs(value) {
    if (!value) return true;
    var url = document.createElement('a');
    url.href = value;
    return url.hostname.lastIndexOf('www.usajobs.gov') > -1 || url.hostname.lastIndexOf('localhost') > -1;
}

function returnToClient(href) {
    Basil.cookie.remove("usaj-cid");
    window.location = href;
}

function storageChange(event) {
    if (event.key === "usaj-l" && event.newValue === "false") {
        location = "/Account/LogOff/";
    }
}
